import { render } from "./SchoolsList.vue?vue&type=template&id=1b8f3e11"
import script from "./SchoolsList.vue?vue&type=script&lang=js"
export * from "./SchoolsList.vue?vue&type=script&lang=js"

import "./SchoolsList.vue?vue&type=style&index=0&id=1b8f3e11&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__